import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=3d473360&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"
import style1 from "./Email.vue?vue&type=style&index=1&id=3d473360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d473360",
  null
  
)

export default component.exports